import { Dropdown } from 'semantic-ui-react';
import { useProjectContext } from '~/hooks';
import toast from 'react-hot-toast';

export default function AdminAutopricingLinkAction() {
   const { project } = useProjectContext();

   const handleCLick = () => {
      if (project.autopricingResult) {
         window.open(project.autopricingResult.spreadsheetUrl, '_blank', 'noopener,noreferrer');
      } else {
         toast.error('Autopricing has not been run yet on this project', { duration: 4000 });
      }
   };

   return (
      <>
         {process.env.REACT_APP_ENV !== 'QA2' ? (
            <Dropdown.Item
               text='View autopricing'
               onClick={handleCLick}
            />
         ) : null}
      </>

   );
}